import moment from 'moment';
export default class PlaidIDVOverride {
	// isIDVSkipped: boolean;
	// skipReason: string | null;
	// skippedBy: SkippedBy | null;

	constructor(init) {
		if (init) {
			this.isIDVSkipped = init.isIDVSkipped;
			this.skipReason = init.skipReason;
			this.skippedBy = new SkippedBy(init.skippedBy);
			this.timestamp = init.timestamp;
		} else {
			this.isIDVSkipped = false;
			this.skipReason = null;
			this.skippedBy = new SkippedBy();
			this.timestamp = moment().utc().toDate();
		}
	}
}

class SkippedBy {
	constructor(init) {
		if (init) {
			this.employeeNumber = init.employeeNumber;
			this.employeeName = init.employeeName;
		} else {
			this.employeeNumber = null;
			this.employeeName = null;
		}
	}
}
